import { ref } from 'vue';

export function useModal () {
	const isModalOpened = ref(false);

	const toggleModal = () => {
		isModalOpened.value = !isModalOpened.value;
	};
	const openModal = () => {
		isModalOpened.value = true;
	};
	const closeModal = () => {
		isModalOpened.value = false;
	};

	return {
		isModalOpened,
		toggleModal,
		openModal,
		closeModal
	};
}
